import { IACDLEvent } from '../../../../../../__legacy__/services/eventBus.service';
import { IImportAnnotationsReport } from '../models/ImportAnnotationsReport';

export const ImportAnnotationsSuccessResponseEventType = Symbol('IMPORT_ANNOTATION_SUCCESS_RESPONSE_EVENT');

export class ImportAnnotationsSuccessResponseEvent implements IACDLEvent {
  constructor(public readonly report: IImportAnnotationsReport) {}

  readonly type: symbol = ImportAnnotationsSuccessResponseEventType;
}
